/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Error_Insufficient_CreditsInputs */

const cs_api_error_insufficient_credits = /** @type {(inputs: Api_Error_Insufficient_CreditsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nedostatek kreditů pro tuto akci.`)
};

const en_api_error_insufficient_credits = /** @type {(inputs: Api_Error_Insufficient_CreditsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not enough credits for this action.`)
};

/**
* | output |
* | --- |
* | "Not enough credits for this action." |
*
* @param {Api_Error_Insufficient_CreditsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const api_error_insufficient_credits = /** @type {((inputs?: Api_Error_Insufficient_CreditsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Error_Insufficient_CreditsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_error_insufficient_credits(inputs)
	return cs_api_error_insufficient_credits(inputs)
});